import Modal from '../../../components/modal/Modal';
import Variables from '../../../style/variables.scss';
import Constants, { BUILDING } from '../../../utils/Constants';
import { formateDecimalNumber } from '../../../utils/FormatNumbers';
import {
  calculateIndoorTotal,
  calculateOutdoorTotal,
} from '../../../utils/Calculations';

const InProgressApartmentModal = ({
  activeApartment,
  openModal,
  closeModal,
  backFromModal,
}: {
  activeApartment: Apartment | null;
  openModal: boolean;
  closeModal: () => void;
  backFromModal: () => void;
}) => {
  return (
    <Modal
      id='apartment_modal'
      isOpen={openModal}
      onClose={closeModal}
      primaryColor={Variables.primaryColor}
      secondaryColor={Variables.secondaryColor}
    >
      <div
        className='inprogress_page_apartment_modal_back'
        onClick={() => {
          document.body.classList.remove('lock_scroll');
          backFromModal();
        }}
      >
        {Constants.arrowLeft(Variables.secondaryColor)}
      </div>
      {activeApartment && (
        <div className='inprogress_page_apartment_modal'>
          <h2 className='text_center'>
            {`ZGRADA ${
              activeApartment.building === BUILDING.C
                ? BUILDING.B
                : activeApartment.building
            } - ${activeApartment.name} ${
              activeApartment.building + activeApartment.apartmentNumber
            }`}
          </h2>
          <div className='inprogress_page_apartment_modal_info'>
            <div className='inprogress_page_apartment_modal_info_plan'>
              <h2>TLOCRT M1:100</h2>
              <img
                src={activeApartment.apartmentImg}
                alt={
                  'apartment_' +
                  activeApartment.building +
                  activeApartment.apartmentNumber
                }
              />
              <a
                href={activeApartment.document}
                rel='noreferrer'
                target='_blank'
                className='inprogress_page_apartment_modal_info_plan_button button_dark opacity_transition_low'
              >
                <div>DOKUMENT PDF</div>
              </a>
            </div>

            <div className='inprogress_page_apartment_modal_info_details'>
              <img
                src={activeApartment.situationImg}
                alt={
                  'situation_' +
                  activeApartment.building +
                  activeApartment.apartmentNumber
                }
              />
              <div className='inprogress_page_apartment_modal_info_details_more'>
                <div className='inprogress_page_apartment_modal_info_details_more_bonus'>
                  <h3>POGODNOSTI</h3>
                  <ul>
                    <li>Protuprovalna ulazna vrata</li>
                    <li>Moderna sobna vrata</li>
                    <li>Klima uređaj</li>
                    <li>Luksuzna sanitarija</li>
                    <li>Keramičke pločice prve klase</li>
                    <li>Hrastov parket prve klase</li>
                    <li>PVC stolarija</li>
                    <li>Video parlafon</li>
                  </ul>
                </div>
                <div className='inprogress_page_apartment_modal_info_details_more_total'>
                  <h3>ISKAZ POVRŠINA</h3>
                  <ol>
                    {activeApartment.entrance && (
                      <li>
                        <div>
                          <span>ULAZ (KER.PL.)</span>
                          <span>
                            {formateDecimalNumber(activeApartment.entrance)}m2
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.hallway && (
                      <li>
                        <div>
                          <span>HODNIK (KER.PL.)</span>
                          <span>
                            {formateDecimalNumber(activeApartment.hallway)}m2
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.kitchen && (
                      <li>
                        <div>
                          <span>KUHINJA (KER.PL.)</span>
                          <span>
                            {formateDecimalNumber(activeApartment.kitchen)}m2
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.livingRoom && (
                      <li>
                        <div>
                          <span>DNEVNI BORAVAK (PARKET)</span>
                          <span>
                            {formateDecimalNumber(activeApartment.livingRoom)}
                            m2
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.foyer && (
                      <li>
                        <div>
                          <span>PREDSOBLJE (KER.PL.)</span>
                          <span>
                            {formateDecimalNumber(activeApartment.foyer)}m2
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.roomOne && (
                      <li>
                        <div>
                          <span>SPAVAĆA SOBA 1 (PARKET)</span>
                          <span>
                            {formateDecimalNumber(activeApartment.roomOne)}m2
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.roomTwo && (
                      <li>
                        <div>
                          <span>SPAVAĆA SOBA 2 (PARKET)</span>
                          <span>
                            {formateDecimalNumber(activeApartment.roomTwo)}m2
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.roomThree && (
                      <li>
                        <div>
                          <span>SPAVAĆA SOBA 3 (PARKET)</span>
                          <span>
                            {formateDecimalNumber(activeApartment.roomThree)}
                            m2
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.bathroom && (
                      <li>
                        <div>
                          <span>KUPAONICA (KER.PL.)</span>
                          <span>
                            {formateDecimalNumber(activeApartment.bathroom)}m2
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.wc && (
                      <li>
                        <div>
                          <span>WC (KER.PL.)</span>
                          <span>
                            {formateDecimalNumber(activeApartment.wc)}m2
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.storageRoom && (
                      <li>
                        <div>
                          <span>SPREMA (KER.PL.)</span>
                          <span>
                            {formateDecimalNumber(activeApartment.storageRoom)}
                            m2
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.garden && (
                      <li>
                        <div>
                          <span>PREDVRT</span>
                          <span>
                            {formateDecimalNumber(activeApartment.garden.total)}
                            m2 (
                            {formateDecimalNumber(
                              activeApartment.garden.sqmNumber
                            )}{' '}
                            x{' '}
                            {formateDecimalNumber(
                              activeApartment.garden.factor
                            )}
                            )
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.balcony && (
                      <li>
                        <div>
                          <span>BALKON</span>
                          <span>
                            {formateDecimalNumber(
                              activeApartment.balcony.total
                            )}
                            m2 (
                            {formateDecimalNumber(
                              activeApartment.balcony.sqmNumber
                            )}{' '}
                            x{' '}
                            {formateDecimalNumber(
                              activeApartment.balcony.factor
                            )}
                            )
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.terrace && (
                      <li>
                        <div>
                          <span>TERASA (NATKR.)</span>
                          <span>
                            {formateDecimalNumber(
                              activeApartment.terrace.total
                            )}
                            m2 (
                            {formateDecimalNumber(
                              activeApartment.terrace.sqmNumber
                            )}{' '}
                            x{' '}
                            {formateDecimalNumber(
                              activeApartment.terrace.factor
                            )}
                            )
                          </span>
                        </div>
                      </li>
                    )}
                    {activeApartment.terraceOpen && (
                      <li>
                        <div>
                          <span>TERASA (NENATKR.)</span>
                          <span>
                            {formateDecimalNumber(
                              activeApartment.terraceOpen.total
                            )}
                            m2 (
                            {formateDecimalNumber(
                              activeApartment.terraceOpen.sqmNumber
                            )}{' '}
                            x{' '}
                            {formateDecimalNumber(
                              activeApartment.terraceOpen.factor
                            )}
                            )
                          </span>
                        </div>
                      </li>
                    )}
                  </ol>
                  <ul>
                    <li>
                      ZATVORENI PROSTOR UKUPNO{' '}
                      <span>{` ${formateDecimalNumber(
                        calculateIndoorTotal(activeApartment)
                      )}m2`}</span>
                    </li>
                    <li>
                      SVEUKUPNO STAN{' '}
                      <span>{`${formateDecimalNumber(
                        calculateOutdoorTotal(activeApartment) +
                          calculateIndoorTotal(activeApartment)
                      )}m2`}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};
export default InProgressApartmentModal;
